// extracted by mini-css-extract-plugin
export default {"container":"_3GTyR","title":"_4-HZV","price":"_2MR1H"};